import { FeatureFlag, useFeatureFlag } from '@/hooks/useFeatureFlags'
import type { ThemeMode } from '@/hooks/useLightMode'

import { Box, Text } from '@chakra-ui/react'

import {
  CloseIcon,
  Box as DarkBox,
  DarkProvider,
  IconButton,
} from '@hivewatch/dark'

import { DrawerCloseButton } from '../../components/DrawerCloseButton'

interface WorkflowDrawerHeaderIProps {
  mode: ThemeMode
  onClose: () => void
}

export const WorkflowDrawerHeader = ({
  mode,
  onClose,
}: WorkflowDrawerHeaderIProps) => {
  const isRebrand = useFeatureFlag(FeatureFlag.incidentDrawerRebrand)

  if (isRebrand) {
    const prefix = mode === 'light' ? 'light.' : ''
    return (
      <DarkProvider>
        <DarkBox
          alignItems='center'
          display='flex'
          gap='12px'
          height='64px'
          justifyContent='space-between'
          pb='16px'
          pt='16px'
          px='24px'
        >
          <DarkBox
            as='span'
            color={`${prefix}text.primary`}
            fontFamily="'Soehne Kraftig', 'Söhne Kräftig', sans-serif"
            fontSize='20px'
            fontWeight='500'
            lineHeight='28px'
            whiteSpace='nowrap'
          >
            Incident Response Workflow
          </DarkBox>
          <IconButton
            _active={{ bg: 'transparent' }}
            aria-label='close workflow drawer'
            colorScheme={mode}
            dimension={36}
            hoverBgColor='transparent'
            icon={<CloseIcon size={11} />}
            onClick={onClose}
          />
        </DarkBox>
      </DarkProvider>
    )
  }

  return (
    <Box
      alignItems='center'
      borderBottomColor={`border.subtle.${mode}`}
      borderBottomWidth='1px'
      display='flex'
      h='65px'
      justifyContent='space-between'
      px='24px'
    >
      <Text fontSize='16px' fontWeight='semibold'>
        Incident Response Workflow
      </Text>
      <DrawerCloseButton onClick={onClose} />
    </Box>
  )
}
